import axios from "axios";
import Cookies from "js-cookie";
import RecProfile from "../components/recruiter/RecProfile";
import SmallBizProfile from "../components/recruiter/small_biz/SmallBizProfile";
import { getUserDetails } from "../utils/getUserDetails";
import { useEffect, useState } from "react";

export default function OrgProfile() {
    const [role, setRole] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRole = async () => {
            try {
                const userDetails = await getUserDetails();
                const userId = userDetails?.id;

                if (userDetails?.role) {
                    setRole(userDetails?.role);
                }

            } catch (error) {
                console.error("Error fetching role", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRole();
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen w-screen">
                <div className="flex flex-col items-center space-y-2">
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    return (
        <RecProfile />
    )
}